// extracted by mini-css-extract-plugin
module.exports =  {"container":"CUoEP2mYCMoV9KugVlxs","label":"a69pfj9worLy2TqqEcMj"};